import React from "react";
import CreateSKU from "./CreateSKU";

function UpdateSKU() {
  return (
    <div>
      <CreateSKU />
    </div>
  );
}

UpdateSKU.auth = {
  path: "/sku/update",
  role: "super-admin admin",
};

export default UpdateSKU;
